import { IPoint2d } from '@/editor/math/IPoint2d';

export function calculatePolygonArea(points: IPoint2d[]): number {
  // 计算多边形面积(用于确定环的方向)
  let area = 0;
  const n = points.length;
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += points[i].x * points[j].y;
    area -= points[j].x * points[i].y;
  }
  return area / 2;
}
